import { formatBytes } from './utils';

export const minDimensions = (width, height) => ({ originalImageInfo: imageInfo }) => {
  if (imageInfo !== null && (imageInfo.width < width || imageInfo.height < height)) {
    throw new Error('dimensions');
  }
};

export const maxFileSize = max => ({ size }) => {
  if (size !== null && formatBytes(size) >= max) {
    throw new Error('size');
  }
};

export const imageType = allowedImageTypes => ({ mimeType }) => {
  if (mimeType !== null && !allowedImageTypes.includes(mimeType)) {
    throw new Error('image');
  }
};



// WEBPACK FOOTER //
// ./src/components/common/UploadcareWidget/validators.js